import { takeLatest, call, put, all } from 'redux-saga/effects';
import { fetchCalendarByYear, fetchCalendarByDate } from '../_services/calendar.services';
import { 
  fetchCalendarByYearSuccess, 
  fetchCalendarByYearFailure,
  fetchCalendarByDateSuccess, 
  fetchCalendarByDateFailure
} from '../_actions/calendar.actions';
import { calendarConstants } from '../_constants/calendar.constants';

export function* fetchCalendarByYearStartAsync({ payload }) {
  try {
    const result = payload.fundId ? yield call(fetchCalendarByDate, payload) : yield call(fetchCalendarByYear, payload);
    yield put(fetchCalendarByYearSuccess(result.data));
  } catch (error) {
    yield put(fetchCalendarByYearFailure(error.message));
  }
}

export function* fetchCalendarByYearStart() {
  yield takeLatest(calendarConstants.FETCH_CALENDAR_BY_YEAR_START, fetchCalendarByYearStartAsync);
}

export function* fetchCalendarByDateStartAsync({ payload }) {
  try {
    const result = yield call(fetchCalendarByDate, payload);
    yield put(fetchCalendarByDateSuccess(result.data));
  } catch (error) {
    yield put(fetchCalendarByDateFailure(error.message));
  }
}

export function* fetchCalendarByDateStart() {
  yield takeLatest(calendarConstants.FETCH_CALENDAR_BY_DATE_START, fetchCalendarByDateStartAsync);
}

export function* calendarSagas() {
  yield all([
    call(fetchCalendarByYearStart),
    call(fetchCalendarByDateStart)
  ]);
}
